import { z } from "zod";

export const siteManagerStatusSchema = z.enum([
  "pending",
  "approved",
  "rejected",
]);

export const siteManagerRequested = z.object({
  type: z.literal("SiteManagerRequested"),
  siteManagerId: z.string().min(1),
  userId: z.string().min(1),
  siteId: z.string().min(1),
  status: siteManagerStatusSchema,
});

export const siteManagerStatusChanged = z.object({
  type: z.literal("SiteManagerStatusChanged"),
  siteManagerId: z.string().min(1),
  status: siteManagerStatusSchema,
  approvedBy: z.string().nullable().optional(),
  approvedAt: z.date().nullable().optional(),
});

export const siteManagerEvents = [
  siteManagerRequested,
  siteManagerStatusChanged,
] as const;
